import { useMemo } from 'react'

import { RoomTranslator } from 'src/translators'
import { useGetCachedRoomsQuery, useGetDiffRoomsQuery } from 'src/types/generated'

type Input = {
  projectId: string
}

export const useGetRooms = ({ projectId }: Input) => {
  // キャッシュされた住戸情報
  const {
    data: cachedData,
    loading,
    refetch: cachedRefetch,
  } = useGetCachedRoomsQuery({
    variables: { projectId },
    skip: projectId === '',
  })
  // 差分情報
  const { data: diffData, refetch: diffRefetch } = useGetDiffRoomsQuery({
    variables: { projectId },
    skip: projectId === '',
  })

  const refetch = async () => Promise.all([cachedRefetch(), diffRefetch()])

  return {
    rooms: useMemo(
      () =>
        cachedData
          ? RoomTranslator.toEntities({
              projectId,
              cachedResponse: cachedData.cachedRooms,
              diffResponse: diffData?.diffRooms,
            })
          : [],
      [cachedData, diffData?.diffRooms, projectId]
    ),
    loading,
    refetch,
  }
}
